/* eslint-disable default-case */
/* eslint-disable no-fallthrough */
import { tagActionTypes } from '@Actions/tagActions';

const TagReducers = (state = {}, action) => {
  switch (action.type) {
  case tagActionTypes.GET_TAGS.LOADING: {
    const { getTagsLoading, entityName } = action;

    if (entityName === 'SALES_ORDER') {
      return {
        ...state,
        getTagsSOLoading: getTagsLoading,
      };
    }
    if (entityName === 'INVOICE') {
      return {
        ...state,
        getTagsInvoiceLoading: getTagsLoading,
      };
    }
    if (entityName === 'PURCHASE_ORDER') {
      return {
        ...state,
        getTagsPOLoading: getTagsLoading,
      };
    }
    if (entityName === 'GRN') {
      return {
        ...state,
        getTagsGRNLoading: getTagsLoading,
      };
    }
    if (entityName === 'PURCHASE_REQUISITION') {
      return {
        ...state,
        getTagsPRLoading: getTagsLoading,
      };
    }
    if (entityName === 'PURCHASE_INDENT') {
      return {
        ...state,
        getTagsPILoading: getTagsLoading,
      };
    }
    if (entityName === 'ACCOUNT_PAYABLE_INVOICE') {
      return {
        ...state,
        apInvoiceLoading: getTagsLoading,
      };
    }
  }

  case tagActionTypes.GET_TAGS.SUCCESS: {
    const { tags, entityName } = action;
    if (tags?.page > 1) {
      if (entityName === 'SALES_ORDER') {
        const tagsCopy = JSON.parse(JSON.stringify(state.tagsSO));
        tagsCopy.data = [...tagsCopy.data, ...tags?.data];
        return {
          ...state,
          tagsSO: tagsCopy,
        };
      }
      if (entityName === 'INVOICE') {
        const tagsCopy = JSON.parse(JSON.stringify(state.tagsInvoice));
        tagsCopy.data = [...tagsCopy.data, ...tags?.data];
        return {
          ...state,
          tagsInvoice: tagsCopy,
        };
      }
      if (entityName === 'PURCHASE_ORDER') {
        const tagsCopy = JSON.parse(JSON.stringify(state.tagsPO));
        tagsCopy.data = [...tagsCopy.data, ...tags?.data];
        return {
          ...state,
          tagsPO: tagsCopy,
        };
      }
      if (entityName === 'GRN') {
        const tagsCopy = JSON.parse(JSON.stringify(state.tagsGRN));
        tagsCopy.data = [...tagsCopy.data, ...tags?.data];
        return {
          ...state,
          tagsGRN: tagsCopy,
        };
      }
      if (entityName === 'PURCHASE_REQUISITION') {
        const tagsCopy = JSON.parse(JSON.stringify(state.tagsPR));
        tagsCopy.data = [...tagsCopy.data, ...tags?.data];
        return {
          ...state,
          tagsPR: tagsCopy,
        };
      }
      if (entityName === 'PURCHASE_INDENT') {
        const tagsCopy = JSON.parse(JSON.stringify(state.tagsPI));
        tagsCopy.data = [...tagsCopy.data, ...tags?.data];
        return {
          ...state,
          tagsPI: tagsCopy,
        };
      }
      if (entityName === 'ACCOUNT_PAYABLE_INVOICE') {
        const tagsCopy = JSON.parse(JSON.stringify(state.apInvoice));
        tagsCopy.data = [...tagsCopy.data, ...tags?.data];
        return {
          ...state,
          apInvoice: tagsCopy,
        };
      }
    } else {
      if (entityName === 'SALES_ORDER') {
        return {
          ...state,
          tagsSO: tags,
        };
      }
      if (entityName === 'INVOICE') {
        return {
          ...state,
          tagsInvoice: tags,
        };
      }
      if (entityName === 'PURCHASE_ORDER') {
        return {
          ...state,
          tagsPO: tags,
        };
      }
      if (entityName === 'GRN') {
        return {
          ...state,
          tagsGRN: tags,
        };
      }
      if (entityName === 'PURCHASE_REQUISITION') {
        return {
          ...state,
          tagsPR: tags,
        };
      }
      if (entityName === 'PURCHASE_INDENT') {
        return {
          ...state,
          tagsPI: tags,
        };
      }
      if (entityName === 'ACCOUNT_PAYABLE_INVOICE') {
        return {
          ...state,
          apInvoice: tags,
        };
      }
    }
  }

  case tagActionTypes.CREATE_TAG.LOADING: {
    const { addTagLoading } = action;
    return {
      ...state,
      addTagLoading,
    };
  }

  default: {
    return state;
  }
  }
};

export default TagReducers;
